import { render, staticRenderFns } from "./UserBalance.vue?vue&type=template&id=527b1b2e&scoped=true"
import script from "./UserBalance.vue?vue&type=script&lang=js"
export * from "./UserBalance.vue?vue&type=script&lang=js"
import style0 from "./UserBalance.vue?vue&type=style&index=0&id=527b1b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b1b2e",
  null
  
)

export default component.exports